<template>
  <div class="body-container">
    <participant-login-disclaimer v-show="isDisclaimerSectionVisible" :isDisclaimerVisible="isDisclaimerSectionVisible" :languageCulture="lang" :widget="widget" />
    <div class="signIn-container signIn-container-xs-screen border-container align-items-center d-inline-grid">
      <template v-if="pwebCognitoAuthentication == false && studies.length == 0">
        <LoginLegacy v-if="!signInWithMobile" @onChangeSigninMethod="changeSignInMethod(true)" :userCredentials="legacyLoginCredentials"></LoginLegacy>
        <!-- TUR-61129 Start -->
        <LoginWithMobile v-else :isOnBackClick="isOnBackClick" :studyId="selectedStudyId" :userCredentials="legacyLoginCredentials" @onChangeSigninMethod="changeSignInMethod(false)" @mobile-input="obj => (phoneObject = obj)" />
        <!--TUR-61129 End -->
      </template>
      <LoginCognito v-if="pwebCognitoAuthentication && studies.length == 0" :userCredentials="cognitoCredentials"></LoginCognito>
      <AuthStudies v-if="studies.length > 1 && pwebCognitoAuthentication == false" :studies="studies" @studySelected="updateStudy" :phoneFlag="signInWithMobile" :mobile="phoneObject"></AuthStudies>
    </div>
    <div id="participants-web" v-if="loading">
      <div class="loader"></div>
    </div>
    <!-- TUR-61129 start-->
    <Modal @modalCallback="modalCallback" :show="showCancelModal" :title="widget.translate('ARE_YOU_SURE_TEXT', 'Are you sure?')" :cancelButton="widget.translate('label_cancel', 'Cancel')" :okButton="widget.translate('label_ok', 'OK')" />
    <!-- TUR-61129 end-->
  </div>
</template>

<script>
import LoginLegacy from "@/components/participant-portal/auth/login/legacy";
import LoginWithMobile from "@/components/participant-portal/auth/login/mobile";
import LoginCognito from "@/components/participant-portal/auth/login/cognito";
import AuthStudies from "@/components/participant-portal/auth/studies";
import nprogress from "nprogress";
import { mapGetters, mapActions } from "vuex";
import { v4 as uuidv4 } from "uuid";
import { Bitrise, Widget, ParticipantPortal } from "@/components/services/participant-service";
const date = new Date();
import moment from "moment";
import Modal from "@/components/participant-portal/common/modal";
import { datadogRum } from "@datadog/browser-rum";
import ParticipantLoginDisclaimer from "../../common/participant-login-disclaimer.vue";

export default {
  name: "login",
  components: {
    Modal,
    LoginLegacy,
    LoginCognito,
    AuthStudies,
    LoginWithMobile,
    ParticipantLoginDisclaimer
  },
  props: ["isOnBackClick", "isOnCancelClick"],
  data() {
    return {
      showCancelModal: false,
      isPhoneOtp: false,
      widget: new Widget(),
      portal: new ParticipantPortal(),
      bitrise: null,
      newGlobalElement: null,
      isStudySelected: false,
      isLanguageCountrySelected: false,
      isLoginSuccess: false,
      activeState: "login",
      signInWithMobile: false,
      phoneObject: null,
      cognitoCredentials: {
        email: "",
        password: "",
        language: this.language,
        country: this.country,
        deviceId: uuidv4(),
        deviceType: "web",
        updatePartLang: false,
        studyId: null,
        studyVersionId: null,
        electronicSignatureSignIn: "",
        isUserAlreadyLoggedIn: false,
        participantLocalTime: date.toISOString(),
        participantLocalTimeOffset: date.toTimeString()
      },
      legacyLoginCredentials: {
        email: "",
        password: "",
        language: this.language,
        country: this.country,
        studyId: this.studyId,
        deviceId: uuidv4(),
        deviceType: "web",
        updatePartLang: true,
        studyVersionId: null,
        isUserAlreadyLoggedIn: false,
        participantLocalTime: date.toISOString(),
        participantLocalTimeOffset: date.toTimeString()
      },

      studies: [],
      language: null,
      country: null,
      selectedStudyId: null,

      defaultLanguage: {},
      defaultCountry: {},

      studyVersionId: null,
      formErrors: false,
      signIndisabled: true,
      pwdError: false,
      emailError: false,
      errorMessage: null,
      threadLogoUrl: null,
      copyrightName: "THREAD",
      loading: false,

      telehealthPublisher: null
    };
  },
  computed: {
    ...mapGetters(["participant", "token", "pwebCognitoAuthentication"]),
    globalElements() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    },
    countries() {
      return this.$store.getters.getParticipantCountries;
    },
    languages() {
      return this.$store.getters.getParticipantLanguages;
    },
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    },
    isDisclaimerSectionVisible() {
      return this.studies.length == 0 && (!this.signInWithMobile || this.pwebCognitoAuthentication);
    }
  },
  mounted() {
    this.$emit("setHeaderOptions", null);
    /** Is Landed from Recritement Site */
    if (this.portal.isLandedFromRecruitmentSite()) {
      this.getOnlyBitriseData();
    }
    /** Is Landed from Recritement Site */

    /** Check if Language & Country are available */
    if (!this.portal.isCountryLanguageAvailable()) {
      this.$router.push({ name: "participants-portal-auth-location" });
    } else {
      this.country = this.portal.getCountry();
      this.language = this.portal.getLanguage();

      this.$emit("setHeaderOptions", null);
      if (this.$route.params && this.$route.params.studyId && !this.portal.isLandedFromRecruitmentSite()) {
        this.$emit("setHeaderOptions", {
          showBlankHeader: true,
          hideCancel: true,
          title: ""
        });
      } else if (this.participant && this.participant.pid !== "" && this.participant.pid !== undefined && this.token !== "" && this.token !== undefined) {
        this.$emit("setHeaderOptions", {});
      }
    }

    this.selectedStudyId = this.portal.isStudyAvailable() ? this.portal.getStudy() : null;
    this.isStudySelected = this.portal.isStudyAvailable();

    /** Check if Participant is already logged in */
    if (this.isStudySelected) {
      if (this.participant && this.participant.pid !== "" && this.participant.pid !== undefined && this.token !== "" && this.token !== undefined) {
        this.redirect("id");
        this.isLoginSuccess = true;
      }

      this.studyVersionId = this.portal.getVersion() ? this.portal.getVersion() : "3";
      this.threadLogoUrl = "https://marketing-image-production.s3.amazonaws.com/uploads/e1d51d2a1da71cd72398505a49a577db12e11426f4a63143818246352efd8c386c5d0da4cbb5b8e4a62f39ef7c55e5141833ba41993eb7dde7af19329f08be56.png";
      if (this.$route.query.error) {
        this.formErrors = { message: this.$route.query.error };
      }
    } else {
      this.$store.dispatch("participantLogout");
    }
    /** Check if Participant is already logged in */

    this.newGlobalElement = this.globalElements;
  },
  watch: {
    isOnCancelClick() {
      this.showCancelModal = !this.showCancelModal;
    },
    isOnBackClick(val) {
      if (val && !this.signInWithMobile) {
        this.$router.push({
          name: "participants-portal-auth-join",
          params: { studyId: this.$route.params.studyId, noLang: true }
        });
      } else {
        this.$emit("setHeaderOptions", null);
        this.signInWithMobile = false;
      }
    },
    participant(user) {
      /** Check if Participant is already logged in */
      if (user.pid !== "" && user.pid !== undefined && this.token !== "" && this.token !== undefined) {
        datadogRum.setUser({
          id: user.pid,
          name: user.userDefinedParticipantId
        });
        datadogRum.addRumGlobalContext("studyId", user.studyId);
        datadogRum.addRumGlobalContext("studyVersionId", user.studyVersionId);
        this.$emit("setHeaderOptions", {});
        const message = this.widget.translate("signed_successfully", "You have logged in successfully.");
        this.$toastr.success(message);
        this.isLoginSuccess = true;
        if (!this.portal.isStudyAvailable() && this.pwebCognitoAuthentication == false) {
          this.getStudies();
        } else {
          this.redirect("id");
        }
      }
      /** Check if Participant is already logged in */
    }
  },
  methods: {
    ...mapActions(["participantLogin", "participantLogout", "participantLoadProfile"]),
    updateLanguage(language) {
      this.language = language;
    },
    // TUR-61129
    changeSignInMethod(isEmailMethod) {
      if (isEmailMethod) {
        this.signInWithMobile = true;
        this.$emit("setHeaderOptions", {
          showBlankHeader: true,
          title: this.widget.translate("label_phone_verification", "Phone Verification"),
          backRouterLink: "participants-portal-auth-login"
        });
      } else {
        this.$emit("setHeaderOptions", null);
        this.signInWithMobile = false;
      }
    },
    modalCallback() {
      this.$emit("setHeaderOptions", null);
      this.signInWithMobile = false;
    },
    //TUR-61129 end
    updateCountry(country) {
      this.country = country;
    },
    updateStudy(studyId) {
      if (studyId) {
        this.isStudySelected = true;
        this.selectedStudyId = studyId;
        const study = this.studies.find(o => o.studyId == studyId);
        /** Participant ID = study.id */
        this.$api
          .getParticipantsProfileDetails(study.participantId)
          .then(response => {
            const participant = response.data;
            participant.myStudyVersionId = participant.studyVersionId;
            this.portal.setLocalStorage("pw-studyId", studyId);
            /** TUR-61129 Start*/
            if (participant.verificationMethod && participant.verificationMethod.toLowerCase() == "phone") {
              participant["verificationMethod"] = "phone";
            } else {
              participant["verificationMethod"] = "email";
            }
            /** TUR-61129 End */
            this.$store.dispatch("participantUpdate", participant);
            this.redirect("id");
          })
          .catch(e => {
            const message = this.widget.translate(e.message, "Problem in fetching profile details.");
            this.$toastr.error(message);
          });
      } else {
        const message = this.widget.translate("pweb_select_study", "Please select a study");
        this.$toastr.error(message);
      }
    },
    confirmParticipant(pid, studyId) {
      const now = new Date();
      const payload = {
        confirmedOnLocal: moment(now).format("YYYY-MM-DDTHH:mm:ss.SSSZZ"),
        confirmedTimeOffset: moment(now).format("Z"),
        isConfirmed: true,
        timezone: moment.tz.guess()
      };
      this.$api
        .confirmParticipant(pid, studyId, payload)
        .then(() => {})
        .catch(err => {
          const message = this.widget.translate(err.message, "Problem in confirming study details.");
          this.$toastr.error(message);
        });
    },
    redirect() {
      if (!this.participant.active) {
        this.getBitriseData();
      } else if (this.$route.query.redirectTo) {
        this.redirectTo(this.$route.query.redirectTo);
      } else {
        this.getBitriseData();
      }
    },
    redirectTo(path) {
      const pattern = /^((http|https):\/\/)/;
      if (pattern.test(path)) {
        window.location.href = path;
      } else {
        this.$router.push(path);
      }
    },
    getStudies() {
      nprogress.start();
      let payload = {
        email: this.participant.email,
        country: this.country,
        deviceType: "web"
      };
      if (this.signInWithMobile) {
        payload = {
          mobile: this.participant.mobile,
          country: this.country,
          deviceType: "web",
          verificationMethod: "phone"
        };
      }
      this.$api
        .getStudies(payload)
        .then(response => {
          if (response.data.studies == null) {
            const message = this.widget.translate("DATA_SYNC_ERROR_MSG", "Problem in fetching study details.");
            this.$toastr.error(message);
            nprogress.done();
          } else {
            this.studies = response.data.studies;
            if (this.studies.length == 1) {
              this.selectedStudyId = this.participant.studyId;
              this.participant.myStudyVersionId = this.participant.studyVersionId;
              this.isStudySelected = true;
              /** TUR-61129 */
              if (this.participant.email && this.participant.email.match(/\S+@\S+\.\S+/) == null) {
                this.participant["verificationMethod"] = "phone";
              } else {
                this.participant["verificationMethod"] = "email";
              }
              /**END OF TUR-61129 */
              this.$store.dispatch("participantUpdate", this.participant);
              this.portal.setLocalStorage("pw-studyId", this.selectedStudyId);
              nprogress.done();
              this.redirect("id");
            } else {
              nprogress.done();
            }
          }
        })
        .catch(e => {
          nprogress.done();
          const message = this.widget.translate(e.message, "Problem in fetching study details.");
          this.$toastr.error(message);
        });
    },
    getOnlyBitriseData() {
      nprogress.start();
      this.portal
        .getBitriseData()
        .then(
          () => {
            this.portal.getGlobalElementsObject();
            nprogress.done();
          },
          () => {
            nprogress.done();
          }
        )
        .catch(() => {
          nprogress.done();
        });
    },
    getBitriseData() {
      nprogress.start();
      this.portal
        .getBitriseData()
        .then(
          () => {
            if (this.participant && this.participant.startDate && this.portal.isParticipantStartToday(this.participant.startDate) && this.portal.isManualStudyStart()) {
              this.confirmParticipant(this.participant.pid, this.participant.studyId);
            }
            this.portal.getGlobalElementsObject();
            nprogress.done();
            const selectedStudyId = this.selectedStudyId ? this.selectedStudyId : this.portal.getStudy();
            this.$router.push({
              name: "participants-portal-activities",
              params: { studyId: selectedStudyId, languageId: this.languageId }
            });
          },
          () => {
            nprogress.done();
          }
        )
        .catch(() => {
          nprogress.done();
        });
    },
    getActivitesData() {
      const bitrise = new Bitrise();
      const studyDataObj = bitrise.getJsonData("study");
      if (studyDataObj) {
        studyDataObj
          .then(response => {
            this.$store.dispatch("setParticipantsPortalStudyData", response);
            nprogress.done();
            this.$router.push({
              name: "participants-portal-activities",
              params: {
                studyId: this.selectedStudyId,
                languageId: this.languageId
              }
            });
          })
          .catch(error => {
            nprogress.done();
            const message = this.widget.translate(error.message, "Data sync failed, please try again after some time.");
            if (message) {
              this.$toastr.error(message);
            }
          });
      }
    },
    getDetails() {
      nprogress.start();
      this.portal
        .getGlobalElementsData()
        .then(
          () => {
            nprogress.done();
            this.redirect("id");
          },
          () => {
            nprogress.done();
            const message = this.widget.translate("pweb_error_not_available", "Web feature is not available.");
            this.$toastr.error(message);
          }
        )
        .catch(() => {
          nprogress.done();
        });
    },
    getApplangaData() {
      this.$api
        .getStaticLanguages(this.language)
        .then(response => {
          const mappedStrings = [];
          response.data.forEach(o => {
            mappedStrings[o.resourceKey] = o.resourceValue;
          }, mappedStrings);
          this.$store.dispatch("setParticipantsPortalStrings", mappedStrings);
        })
        .catch(e => {
          const message = this.widget.translate(e.message, "Problem in fetching language translations.");
          this.$toastr.error(message);
        });
    },
    // TUR-61129
    updateActiveScreen() {
      this.isPhoneOtp = true;
    }
    //END OF TUR-61129
  }
};
</script>

<style scoped lang="scss">
.cursor-pointer {
  cursor: pointer;
}
.signIn-btn {
  -webkit-transition: all 0.5s;
  -moz-transition: all 0.5s;
  -o-transition: all 0.5s;
  transition: all 0.5s;
  position: relative;
  border: none;
}
.signIn-btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 0%;
  height: 100%;
  z-index: 1;
  opacity: 0;
  background-color: rgba(255, 255, 255, 0.5);
  -webkit-transition: all 0.4s;
  -moz-transition: all 0.4s;
  -o-transition: all 0.4s;
  transition: all 0.4s;
}
.signIn-btn:hover::before {
  opacity: 1;
  width: 100%;
}
.main-container {
  margin: 30px 161px auto;
}
.profile-header .row,
.body-container .row {
  margin-right: 0px;
  margin-left: 0px;
}
.brand-logo {
  width: 210px;
  height: 69px;
}

.icon {
  width: 30px;
  height: 30px;
  position: relative;
}
.txt-question {
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  position: absolute;
  padding: 2px;
  top: 2px;
  left: 10px;
  border-radius: 25px;
}
.notification-count {
  color: var(--secondary);
  font-size: 16px;
  font-weight: bold;
  position: absolute;
  padding: 2px;
  top: 2px;
  left: 28px;
  border-radius: 25px;
}
.fa-comment,
.fa-bell {
  color: var(--secondary);
}

.profile-header .nav a {
  flex-grow: 0;
  font-family: Roboto;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.14;
  text-align: center;
  color: #9b9b9b;
}
.profile-header .nav a:hover {
  color: var(--secondary);
}

.profile-header .nav span:hover {
  color: var(--secondary);
}

.text-id {
  font-family: Roboto;
  font-size: 17px;
  font-weight: 500;
  line-height: 1.29;
  letter-spacing: -0.41px;
  text-align: left;
  color: #4a4a4a;
}
.sidebar .nav-link {
  display: block;
  padding: 19px 15px;
  font-size: 17px;
}
.sidebar .nav-link {
  color: #4a4a4a;
}
.sidebar .nav-link:hover {
  color: var(--secondary);
}
.sidebar .nav-item {
  border-bottom: solid 1px #d8e3e7;
}
.btn-signOut {
  font-size: 17px;
  color: #ffffff;
  width: 271.2px;
  height: 44px;
  border-radius: 12px;
  background-color: #c4c4c4;
}
.btn-account {
  font-size: 17px;
  color: #ffffff;
  width: 271.2px;
  height: 44px;
  border-radius: 12px;
  background-color: var(--secondary);
}
.next {
  color: #9b9b9b;
}
.privacy-info .nav-link {
  font-size: 14px;
  display: block;
  padding: 0.25rem 1rem;
  color: var(--primary) !important;
  cursor: pointer;
}
.app-info {
  font-size: 13px;
  color: #9b9b9b;
}
#profile-tab .form-group {
  position: relative;
  margin: 30px 101px 27px 46px;
  border: solid 1px rgba(0, 0, 0, 0.12);
  height: 56px;
  padding: 2px;
  opacity: 0.6;
  border-radius: 4px;
}
#profile-tab .form-group > label {
  font-size: 12px;
  position: absolute;
  top: -15px;
  left: 17px;
  padding: 5px;
  background-color: white;
}
/* Confirmation Email Modal */
.confirmEmailTitle {
  font-family: Roboto;
  font-size: 24px;
  font-weight: 500;
  line-height: 0.92;
  letter-spacing: -0.41px;
  text-align: center;
  color: #4a4a4a;
}

/* SignIn Page css */

.signIn-btn {
  color: #ffffff;
  width: 100%;
  height: 44px;
  margin-top: 44px;
  padding: 11px 58px 18px 58px;
  border-radius: 6px;
  background-color: var(--secondary);
}
.signIn-box .form-control {
  padding: 16px;
}
.forgot-link {
  color: var(--primary);
  font-size: 16px;
  font-weight: 500;
}
.forgot-link a {
  color: var(--secondary);
}
/* Styles for forgot username */

.forgot-uname input {
  padding: 16px 18px;
}
.forgot-uname {
  padding-bottom: 56px;
  padding-top: 32px;
}
.forgotUname-box {
  width: 40%;
  height: auto;
  margin: auto;
  padding: 70px 50px;
  border-radius: 8px;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
}
.ForgotUname-container {
  position: relative;
  width: 100%;
  height: 977px;
  background-image: radial-gradient(#ffffff, rgba(255, 255, 255, 0)), linear-gradient(to bottom, #f3f3f4, #f3f3f4);
}
.card.activity-list-help-card {
  border-radius: 10px;
  box-shadow: -2px 2px 8px 0 rgba(0, 0, 0, 0.14);
  margin-bottom: 40px;
}
.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}
/* Styles for forgot username */
.pid-title {
  font-size: 22px;
  padding-bottom: 20px;
  padding-top: 50px;
}
.pid-btn {
  margin-top: 100px;
}
.forgot-container,
.loading {
  margin-top: 200px !important;
}
.loading {
  height: auto !important;
}

// For mobile screens
@media only screen and (max-width: 600px) {
  .signIn-container-xs-screen {
    min-height: 0px !important;
  }
}
</style>
